import script from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"

import "./MaintenancePage.vue?vue&type=style&index=0&id=bc575ed2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc575ed2"]])

export default __exports__